import {Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../service/progress.service';
import {School, SchoolType} from '../../model/location/School';
import {BaseModalComponent} from '../../common/modal/base-modal/base-modal.component';
import {NotificationHandler} from '../../helper/notification.handler';
import {LocationService} from '../../service/location.service';
import {Locale} from '../../model/Locale';

export interface SchoolDetailsData {
  schoolId: string;
}

@Component({
  selector: 'school-details-modal',
  templateUrl: './school-details-modal.component.html',
  styleUrls: ['./school-details-modal.component.scss']
})
export class SchoolDetailsModalComponent extends BaseModalComponent implements OnInit {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  readonly schoolId: string;
  school?: School;
  schoolTypes?: SchoolType[];

  constructor(private locationService: LocationService,
              @Inject(LOCALE_ID) private locale: string,
              dialogRef: MatDialogRef<SchoolDetailsModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: SchoolDetailsData) {
    super(dialogRef, progressService);

    this.schoolId = data.schoolId;
  }

  proceedAllowed(): boolean {
    return true;
  }

  ngOnInit(): void {
    this.loadSchoolTypes();
    this.loadSchoolDetails(this.schoolId);
  }

  private loadSchoolTypes() {
    this.locationService.getSchoolTypes(this.locale as Locale).subscribe(types => {
      this.schoolTypes = types;
    });
  }

  private loadSchoolDetails(schoolId: string) {
    this.startProgress();

    this.locationService.getSchoolDetails(schoolId).subscribe(school => {
      this.school = school;
    }, error => {
      NotificationHandler.handleError($localize`:Notifications|School details fetch has failed message@@notifications-school-details-fetch-failed-error:School details fetch has failed`, error);
    }, () => this.stopProgress());
  }

  proceed(): void {
    this.closeModal();
  }

}
